"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    resourceAccountPlugin: ()=>resourceAccountPlugin
});
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
const query_config_js_namespaceObject = require("../../../utils/query.config.js");
const external_gateway_js_namespaceObject = require("../gateway.js");
const PROXY_INJECT_HEADER_FOR_SINF_KEY = 'bytecloud-pedestal-inject-x-bcgw-sinf-account-id';
const showLog = (0, query_config_js_namespaceObject.libHasQuery)('x-bc-resource-account-log');
function resourceAccountPlugin(param) {
    let { sinfAccountIdKey = 'x-bcgw-sinf-account-id', shouldAttachSinfAccountIdHeader, tenantIdKey = 'x-bcgw-tenant-id', shouldAttachTenantIdHeader, platformLike, garfishNamespace } = param;
    var _self_getBytecloudContext, _context_getResourceConfig;
    if ('function' != typeof (null == self ? void 0 : self.getBytecloudContext)) return {};
    const module = platformLike || window.location.pathname.split('/')[1] || 'unknown';
    const context = null == (_self_getBytecloudContext = self.getBytecloudContext) ? void 0 : _self_getBytecloudContext.call(self, module, garfishNamespace);
    if ('function' != typeof (null == context ? void 0 : context.getProxyHeaderRule)) return {};
    const resourceConfig = null == (_context_getResourceConfig = context.getResourceConfig) ? void 0 : _context_getResourceConfig.call(context);
    if (!resourceConfig) return {};
    const getRule = once_default()(()=>context.getProxyHeaderRule((rule)=>rule.key === PROXY_INJECT_HEADER_FOR_SINF_KEY));
    return {
        request: [
            async (config)=>{
                var _config_pluginConfig_gatewayRequestConfigKey, _config_pluginConfig;
                const isValidResourceAccount = Boolean(null == resourceConfig ? void 0 : resourceConfig.resourceAccountItemConfig);
                const injectRule = getRule();
                const targetURL = config.url || (null == (_config_pluginConfig = config.pluginConfig) ? void 0 : null == (_config_pluginConfig_gatewayRequestConfigKey = _config_pluginConfig[external_gateway_js_namespaceObject.gatewayRequestConfigKey]) ? void 0 : _config_pluginConfig_gatewayRequestConfigKey.url);
                const alreadyInjectedSInfIdInAdvanced = targetURL && (null == injectRule ? void 0 : injectRule.matcher.test(targetURL));
                if (showLog) console.log('resourceAccountPlugin', {
                    config,
                    targetURL,
                    isValidResourceAccount,
                    injectRule,
                    alreadyInjectedSInfIdInAdvanced,
                    shouldAttachSinfAccountIdHeader,
                    shouldAttachTenantIdHeader,
                    sinfAccountIdKey,
                    tenantIdKey
                });
                if (isValidResourceAccount && !alreadyInjectedSInfIdInAdvanced && ('boolean' == typeof shouldAttachSinfAccountIdHeader ? shouldAttachSinfAccountIdHeader : await (null == shouldAttachSinfAccountIdHeader ? void 0 : shouldAttachSinfAccountIdHeader(config, resourceConfig)))) {
                    var _resourceConfig_resourceAccountItemConfig;
                    config.headers = config.headers || {};
                    config.headers[sinfAccountIdKey] = null == (_resourceConfig_resourceAccountItemConfig = resourceConfig.resourceAccountItemConfig) ? void 0 : _resourceConfig_resourceAccountItemConfig.mainAccountID;
                }
                if (isValidResourceAccount && ('boolean' == typeof shouldAttachTenantIdHeader ? shouldAttachTenantIdHeader : await (null == shouldAttachTenantIdHeader ? void 0 : shouldAttachTenantIdHeader(config, resourceConfig)))) {
                    var _resourceConfig_resourceAccountItemConfig1;
                    config.headers = config.headers || {};
                    config.headers[tenantIdKey] = null == (_resourceConfig_resourceAccountItemConfig1 = resourceConfig.resourceAccountItemConfig) ? void 0 : _resourceConfig_resourceAccountItemConfig1.tenant;
                }
                return config;
            }
        ],
        response: []
    };
}
exports.resourceAccountPlugin = __webpack_exports__.resourceAccountPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "resourceAccountPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
